export { default as FilterTag } from '@source/pages/Home/components/FilterTag/FilterTag';

export type { FilterTagProps } from '@source/pages/Home/components/FilterTag/FilterTag';
